const INIT_PHASING_DATA_SOURCE_STATE = {
  phasingData: []
};

const PhasingDataSource = (state = INIT_PHASING_DATA_SOURCE_STATE, action) => {
  switch (action.type) {
    case 'PHASING_DATA':
      return {
        ...state,
        phasingData: action.payload
      };
    default:
      return state;
  }
};

const INIT_PHASING_TYPE_STATE = {
  phasingType: ''
};

const PhasingType = (state = INIT_PHASING_TYPE_STATE, action) => {
  switch (action.type) {
    case 'PHASING_TYPE':
      return {
        ...state,
        phasingType: action.payload
      };
    default:
      return state;
  }
};

export {PhasingDataSource, PhasingType};
